import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaInstagram,
  FaWhatsapp,
  FaPhoneAlt,
  FaClock,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { FiPhone } from "react-icons/fi";
import "../styles/Footer.scss";
import { useFooterData } from "../Apis/useApiQueries";
import { scrollToTop } from "../utils/scrollToTop";

const Footer = ({ isAcademyPage = false }) => {
  const { siteDetails, treatments, treatmentsRefs, error } = useFooterData();
  const navigate = useNavigate();

  // Function to handle link clicks and scroll to top
  const handleLinkClick = (path) => {
    // Navigate to the new page
    navigate(path);

    // Scroll to top using the utility function
    scrollToTop();
  };

  if (error) {
    return <p className="footer-error">Error: {error.message}</p>;
  }

  if (!siteDetails.data) {
    return null; // Avoid rendering if footerDetails is null
  }

  // Simple footer for Academy page only
  if (isAcademyPage) {
    return (
      <footer className="compact-footer academy-footer" dir="rtl">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand-social">
              <div className="brand-info">
                <h3 className="brand-name">ד״ר שי תלם</h3>
                <span className="brand-tagline">רפואה אסתטית מתקדמת</span>
              </div>

              <div className="social-icons-simple" style={{ 
                display: 'flex', 
                gap: '12px', 
                alignItems: 'center',
                position: 'relative',
                zIndex: 100,
                pointerEvents: 'auto'
              }}>
                <a
                  href="https://www.instagram.com/dr_shay_telem/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '50%',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    zIndex: 101,
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                  }}
                >
                  <FaInstagram size={20} color="#ffffff" />
                </a>
                <a
                  href="https://api.whatsapp.com/message/LNFLYSQDUAFWK1?autoload=1&app_absent=0&utm_source=ig"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="WhatsApp"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '50%',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    zIndex: 101,
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                  }}
                >
                  <FaWhatsapp size={20} color="#ffffff" />
                </a>
                <a
                  href="tel:053-226-8138"
                  aria-label="טלפון"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    borderRadius: '50%',
                    textDecoration: 'none',
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    zIndex: 101,
                    pointerEvents: 'auto',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'scale(1.1)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'scale(1)';
                    e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                    e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                  }}
                >
                  <FiPhone size={20} color="#ffffff" strokeWidth={2} />
                </a>
              </div>
            </div>

            <div className="academy-address-compact">
              <FaMapMarkerAlt className="address-icon" />
              <div className="address-text">
                <span className="main-address">מגדלי בסר 2, רמת גן • קומה 7</span>
                <span className="exact-address">כתובת מדויקת: רח' בן גוריון 1 בני ברק</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  // Modern redesigned footer for all other pages
  return (
    <footer className="modern-footer-redesigned" dir="rtl">
      <div className="footer-container">
        <div className="footer-content-grid">
          {/* Brand Section */}
          <div className="footer-brand-section">
            <div className="brand-header">
              <h2 className="brand-title">ד״ר שי תלם</h2>
              <p className="brand-subtitle">רפואה אסתטית מתקדמת</p>
              <p className="brand-description">
                מובילים בתחום הרפואה האסתטית עם טכנולוגיות מתקדמות וטיפולים מותאמים אישית
              </p>
            </div>
            
            <div className="social-media-section">
              <h3 className="section-title">עקבו אחרינו</h3>
              <div className="social-links-modern">
                <a
                  href="https://www.instagram.com/dr_shay_telem/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link instagram"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                  <span>Instagram</span>
                </a>
                <a
                  href="https://api.whatsapp.com/message/LNFLYSQDUAFWK1?autoload=1&app_absent=0&utm_source=ig"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link whatsapp"
                  aria-label="WhatsApp"
                >
                  <FaWhatsapp />
                  <span>WhatsApp</span>
                </a>
                <a
                  href="tel:053-226-8138"
                  className="social-link phone"
                  aria-label="טלפון"
                >
                  <FiPhone />
                  <span>התקשרו עכשיו</span>
                </a>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="footer-contact-section">
            <h3 className="section-title">פרטי התקשרות</h3>
            
            <div className="contact-info-modern">
              <div className="contact-item-modern">
                <div className="contact-icon-wrapper">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-details-modern">
                  <h4>מרפאת הרצליה</h4>
                  <p>רחוב סוקולוב 27, הרצליה</p>
                  <div className="navigation-links">
                    <a
                      href="https://waze.com/ul?q=רחוב סוקולוב 27 הרצליה&navigate=yes"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link waze"
                    >
                      נווט ב-Waze
                    </a>
                    <a
                      href="https://maps.google.com/?q=רחוב סוקולוב 27, הרצליה"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link maps"
                    >
                      Google Maps
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-item-modern">
                <div className="contact-icon-wrapper">
                  <FaMapMarkerAlt />
                </div>
                <div className="contact-details-modern">
                  <h4>מרפאת באר שבע</h4>
                  <p>אליהו נאוי 24 (מתחם וורקיז קומת כניסה), באר שבע</p>
                  <div className="navigation-links">
                    <a
                      href="https://waze.com/ul?q=אליהו נאוי 24 באר שבע&navigate=yes"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link waze"
                    >
                      נווט ב-Waze
                    </a>
                    <a
                      href="https://maps.google.com/?q=אליהו נאוי 24, באר שבע"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-link maps"
                    >
                      Google Maps
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-item-modern">
                <div className="contact-icon-wrapper">
                  <FaClock />
                </div>
                <div className="contact-details-modern">
                  <h4>שעות פעילות</h4>
                  <div className="hours-info">
                    <p>א'-ה': 09:00 - 20:00</p>
                    <p>ו': 09:00 - 14:00</p>
                    <p>ש': סגור</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Services Section */}
          <div className="footer-services-section">
            <h3 className="section-title">הטיפולים שלנו</h3>
            <div className="services-grid-modern">
              {/* Treatment References (categories) */}
              {treatmentsRefs.data?.slice(0, 6).map((treatment) => (
                <button
                  key={treatment._id}
                  onClick={() => handleLinkClick(`/treatments/${treatment.treatmentRef}`)}
                  className="service-link-modern"
                >
                  {treatment.treatmentRef}
                </button>
              ))}
              
              {/* Individual Treatments (filtered to avoid duplicates) */}
              {treatments.data
                ?.filter((treatment) =>
                  !treatmentsRefs.data?.some(
                    (refTreatment) =>
                      refTreatment.treatmentRef === treatment.treatmentRef
                  )
                )
                ?.slice(0, Math.max(0, 8 - (treatmentsRefs.data?.length || 0)))
                .map((treatment) => (
                  <button
                    key={treatment._id}
                    onClick={() => handleLinkClick(`/treatment/${treatment.name}`)}
                    className="service-link-modern"
                  >
                    {treatment.name}
                  </button>
                ))}
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom-modern">
          <div className="footer-bottom-content">
            <p className="copyright">
              &copy; {new Date().getFullYear()} ד״ר שי תלם - רפואה אסתטית מתקדמת. כל הזכויות שמורות.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;